import { useEffect, useState, useContext } from 'react'
import { useAppStore, StoreContext } from '../../shared/store/store'
import * as datGui from 'dat.gui'
import * as THREE from 'three'
import * as PostProcessing from 'postprocessing'

import { ModelControls } from '../utils/ModelControls'
import { IPostEffects } from '../posteffects/posteffects'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { setupGUI } from '../posteffects/GUI/GUI'
import { SceneLight } from '../types/scene-light'
import styles from '../../styles.module.css'

export function useGUI(
  jewelryModel: THREE.Object3D | undefined,
  renderer: THREE.WebGLRenderer | undefined,
  composer: PostProcessing.EffectComposer | undefined,
  postEffects: IPostEffects | undefined,
  controls: ModelControls | OrbitControls | undefined,
  scene: THREE.Scene,
  camera: THREE.PerspectiveCamera,
  lights: SceneLight[] | undefined,
  rootElem: HTMLElement | undefined,
  cubemap: THREE.DataTexture | undefined,
) {
  const store = useContext(StoreContext)
  const isGUIEnabled = useAppStore((state) => state.isGUIEnabled)
  const [gui, setGui] = useState<datGui.GUI | undefined>(undefined)

  useEffect(() => {
    if (
      !jewelryModel ||
      !renderer ||
      !composer ||
      !postEffects ||
      !controls ||
      !lights ||
      !rootElem
    )
      return
    if (isGUIEnabled && !gui) {
      const axesHelper = new THREE.AxesHelper(5)
      axesHelper.visible = false
      scene.add(axesHelper)

      const bbox = new THREE.BoxHelper(jewelryModel, 0xff0000)
      bbox.visible = false
      scene.add(bbox)

      const gui = setupGUI({
        renderer,
        composer,
        postEffects,
        camera,
        axesHelper,
        lights,
        bbox,
        controls,
        scene,
        store,
        cubemap,
      })

      rootElem.appendChild(gui.domElement)
      gui.domElement.classList.add(styles.gui_container)
      setGui(gui)
    } else if (!isGUIEnabled && gui) {
      gui.destroy()
      setGui(undefined)
    }
  }, [isGUIEnabled, jewelryModel, renderer, composer, postEffects, controls])

  useEffect(() => {
    return () => {
      if (gui) {
        gui.destroy()
      }
    }
  }, [])
}
